<script lang="ts">
  import { BADGE_ID } from "../..";

  export let header: string | null = "";
  export let text: string | null = "";
  export let modalCallback: () => void;
</script>

<div id={BADGE_ID} class="pina-badge">

  <img 
    class="pina-badge-image"
    src="https://pinaclimateapp.blob.core.windows.net/static/assets/RookieBabyBadgeImage.webp"
    />


  <div class="pina-text-container">
    <div class="pina-badge-header-text">
      {header}
    </div>
    <div class="pina-badge-body-text">
      {text}
    </div>
  </div>

</div>

<style>
  .pina-badge {
    font-family: "Futura";
    margin: 1rem 0;
    padding: 0.75rem;
    background: #ECE5DF;
    box-shadow: #0000004d 2px 2px 14px 1px;
    line-height: 0.6rem;
    display: flex;
  }

  .pina-badge-image {
    border-radius: 50%;
    object-fit: cover;
    height: 125px;
    min-width: 125px;
    padding: 10px;
    object-position: 0 0;
  }

  .pina-badge-header-text {
    font-weight: 700;
    font-size: 11px;
    margin-bottom: 0.5rem;
    line-height: 1rem;

    @media only screen and (min-width: 450px) {
      font-size: 12px;
    }
  }

  .pina-modal-link:hover {
    cursor: pointer;
  }

  .pina-badge-body-text {
    font-size: 11px;
    line-height: normal;
    margin-top: 0.5rem;
    padding-left: 0px;

    @media only screen and (min-width: 450px) {
      font-size: 12px;
    }
    
  }
</style>
